<div style="width:100%; height: 100%">
  <div id="map" #mapElement></div>
</div>